<template>
    <div class="row">
        <div class="col-lg-4 mb-1 mb-lg-0">
            <b-card class="p-1" no-body>
                <h4 class="text-muted">Genel Bilgiler</h4>
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Ad</label>
                                <input class="form-control" placeholder="Ad" v-model="request.FirstName"/>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Soyad</label>
                                <input class="form-control" placeholder="Soyad" v-model="request.LastName"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Kimlik Numarası</label>
                        <input class="form-control" placeholder="Kimlik Numarası" v-model="request.IdentityNumber"/>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Sicil Numarası</label>
                        <input class="form-control" placeholder="Sicil Numarası" v-model="request.RegistrationCode"/>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Cinsiyet</label>
                        <select class="form-control" v-model="request.Gender">
                            <option v-for="g in genders" :value="g.value">{{ g.text }}</option>
                        </select>
                    </div>
                    <div class="col-12">
                        <div class="border-bottom mb-25 pb-25">
                            <small>Engellilik</small>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Minimum</label>
                                <input type="number" class="form-control" placeholder="Minimum" v-model="request.DisabilityRateMin"/>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Maksimum</label>
                                <input type="number" class="form-control" placeholder="Maksimum"v-model="request.DisabilityRateMax"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="border-bottom mb-25 pb-25">
                            <small>Doğum Tarihi</small>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Başlangıç</label>
                                <v-date-picker placeholder="Başlangıç" v-model="request.BirthDateStart"></v-date-picker>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Bitiş</label>
                                <v-date-picker placeholder="Bitiş" v-model="request.BirthDateEnd"></v-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Kan Grubu</label>
                        <v-select-list multiple :options="bloods" v-model="blood" label="Name" placeholder="Kan Grubu"></v-select-list>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Medeni Durumu</label>
                        <v-select-list multiple :options="maritialStatuses" v-model="maritialStatus" label="Name" placeholder="Medeni Durumu"></v-select-list>
                    </div>
                   <div class="col-12">
                        <label class="form-label">İşe Alımı Sakıncalı</label>
                        <select class="form-control" v-model="request.Harmful">
                            <option :value="null">Tümü</option>
                            <option :value="true">Evet</option>
                            <option :value="false">Hayır</option>
                        </select>
                    </div>
                </div>
            </b-card>
        </div>
        <div class="col-lg-4 mb-1 mb-lg-0">
            <b-card class="p-1 mb-1" no-body>
                <h4 class="text-muted">SGK</h4>
                <div class="row">
                    <div class="col-lg-6 mb-1">
                        <label class="form-label">Durum</label>
                        <select class="form-control" v-model="request.Active">
                            <option v-for="g in status" :value="g.value">{{ g.text }}</option>
                        </select>
                    </div>
                    <div class="col-lg-6 mb-1">
                        <label class="form-label">Çalışma Zamanı</label>
                        <select class="form-control" v-model="request.PartTime">
                            <option v-for="g in times" :value="g.value">{{ g.text }}</option>
                        </select>
                    </div>
                    <div class="col-12">
                        <div class="border-bottom mb-25 pb-25">
                            <small>İşe Giriş</small>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Başlangıç</label>
                                <v-date-picker placeholder="Başlangıç" v-model="request.SGKEntryNoticeStart"></v-date-picker>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Bitiş</label>
                                <v-date-picker placeholder="Bitiş" v-model="request.SGKEntryNoticeEnd"></v-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="border-bottom mb-25 pb-25">
                            <small>İşten Çıkış</small>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Başlangıç</label>
                                <v-date-picker placeholder="Başlangıç" v-model="request.SGKExitNoticeStart"></v-date-picker>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Bitiş</label>
                                <v-date-picker placeholder="Bitiş" v-model="request.SGKExitNoticeEnd"></v-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Şube</label>
                        <v-select-list multiple :options="sgkBranches" v-model="sgkBranch" label="Name" placeholder="Şube"></v-select-list>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Meslek Kodu</label>
                        <v-select-list multiple v-model="jobCode" :options="jobCodes" label="Combine" v-on:search="searchOT" placeholder="Meslek Kodu" :loading="loadingOT"></v-select-list>
                    </div>
                    <div class="col-12">
                        <label class="form-label">EYT</label>
                        <select class="form-control" v-model="request.EYT">
                            <option :value="null">Tümü</option>
                            <option :value="true">Evet</option>
                            <option :value="false">Hayır</option>
                        </select>
                    </div>
                </div>
            </b-card>
        </div>
        <div class="col-lg-4 mb-1 mb-lg-0">
            <b-card class="p-1 mb-1" no-body>
                <h4 class="text-muted">Organizasyonel</h4>
                <div class="row">
                    <div class="col-12">
                        <div class="border-bottom mb-25 pb-25">
                            <small>Giriş</small>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Başlangıç</label>
                                <v-date-picker placeholder="Başlangıç" v-model="request.EmployeeBranchEntryDateStart"></v-date-picker>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Bitiş</label>
                                <v-date-picker placeholder="Bitiş" v-model="request.EmployeeBranchEntryDateEnd"></v-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="border-bottom mb-25 pb-25">
                            <small>Çıkış</small>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Başlangıç</label>
                                <v-date-picker placeholder="Başlangıç" v-model="request.EmployeeBranchExitDateStart"></v-date-picker>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Bitiş</label>
                                <v-date-picker placeholder="Bitiş" v-model="request.EmployeeBranchExitDateEnd"></v-date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Şube</label>
                        <v-select-list multiple :options="oBranches" v-model="oBranch" label="Name" placeholder="Şube"></v-select-list>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Bölüm</label>
                        <v-select-list multiple :options="departments" v-model="department" label="Combine" placeholder="Bölüm"></v-select-list>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Unvan</label>
                        <v-select-list multiple :options="titles" v-model="title" label="Combine" placeholder="Unvan"></v-select-list>
                    </div>
                    <div class="col-12 mb-1">
                        <label class="form-label">Garaj</label>
                        <v-select-list multiple :options="garages" v-model="garage" label="Combine" placeholder="Garaj"></v-select-list>
                    </div>
                    <div class="col-12">
                        <div class="border-bottom mb-25 pb-25">
                            <small>Garaj Geçmişi (Tarih Aralığı)</small>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Başlangıç</label>
                                <v-date-picker placeholder="Başlangıç" v-model="request.GarageStartDateFilter"></v-date-picker>
                            </div>
                            <div class="col-lg-6 mb-1">
                                <label class="form-label">Bitiş</label>
                                <v-date-picker placeholder="Bitiş" v-model="request.GarageEndDateFilter"></v-date-picker>
                            </div>
                            <div class="col-12">
                                <small class="text-muted">
                                    Tarih girmezseniz her personel için güncel garaj gelir. Tarih aralığı
                                    girdiğinizde, o aralıkta personelin çalıştığı her garaj ayrı satır olarak
                                    listelenir; her satırda o dönemdeki şube ve dijital ehliyet bilgisi gösterilir.
                                </small>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <label class="form-label">Yaka</label>
                        <v-select-list multiple :options="collarStatuses" v-model="collarStatus" label="Name" placeholder="Yaka"></v-select-list>
                    </div>
                </div>
            </b-card>
            <b-card class="p-1" no-body>
                <h4 class="text-muted">Kolonlar</h4>
                <div class="card-columns g-50">
                    <div class="card border p-50 mb-50" v-for="(items,g) of c_fields">
                        <h6 class="text-muted">{{ g }}</h6>
                        <b-form-checkbox v-for="(f,i) of items" :key="i" :checked="selectedFields.includes(f.value)" v-on:input="addSelected(f)" :disabled="f.disabled"><small>{{ f.text }}</small></b-form-checkbox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mt-75">
                        <v-executer class="w-100" :loading="loading" :action="send">Rapor Al</v-executer>
                    </div>
                </div>
            </b-card>
        </div>
    </div>
</template>

<script>
import { BCard, BFormCheckbox, BFormSelect } from 'bootstrap-vue';
import SystemDataApi from '@/api/system-data'
import CompanyApi from '@/api/company'
import VehicleOperationsApi from '@/api/vehicle-operations'
import HumanResourcesParametersApi from '@/api/human-resources-parameters';
import EmployeeOperationsApi from '@/api/employee-operations';
import Additional from '@/utilities/additional';
export default {
    components:{
        BCard,
        BFormCheckbox,
        BFormSelect
    },
    mounted(){
        this.getBloods()
        this.getMaritialStatuses()
        this.getSGKBranches()
        this.getOBranches()
        this.getCollarStatuses()
        this.getGarages()
        this.getDepartments()
        this.getTitles()
    },
    data(){
        return {
            genders:[
                {text:"Tümü",value:null},
                {text:"Erkek",value:true},
                {text:"Kadın",value:false},
            ],
            status:[
                {text:"Tümü",value:null},
                {text:"Çalışıyor",value:true},
                {text:"Ayrıldı",value:false},
            ],
            times:[
                {text:"Tümü",value:null},
                {text:"Yarı Zamanlı",value:true},
                {text:"Tam Zamanlı",value:false},
            ],
            bloods:[],
            maritialStatuses:[],
            sgkBranches:[],
            oBranches:[],
            jobCodes:[],
            loadingOT:false,
            collarStatuses:[],
            garages:[],
            departments:[],
            titles:[],
            request:{
                FirstName:null,
                LastName:null,
                IdentityNumber:null,
                Gender:null,
                RegistrationCode:null,
                BirthDateStart:null,
                BirthDateEnd:null,
                MaritialStatusIds:[],
                BloodGroupIds:[],
                SGKEntryNoticeStart:null,
                SGKEntryNoticeEnd:null,
                SGKExitNoticeStart:null,
                SGKExitNoticeEnd:null,
                SGKBranchIds:[],
                OccupationTitleIds:[],
                EmployeeBranchEntryDateStart:null,
                EmployeeBranchEntryDateEnd:null,
                EmployeeBranchExitDateStart:null,
                EmployeeBranchExitDateEnd:null,
                OperationalBranchIds:[],
                CollarStatusIds:[],
                DisabilityRateMin:null,
                DisabilityRateMax:null,
                Active:null,
                PartTime:null,
                VehicleInventoryGarageIds:[],
                GarageStartDateFilter:null,
                GarageEndDateFilter:null,
                EmployeeDepartmentTitleIds:[],
                EmployeeDepartmentIds:[],
                EYT:null,
                Harmful: null
            },
            selectedFields:['IdentityNumber','FullName'],
            fields:[
                {
                    "value": "IdentityNumber",
                    "text": "Kimlik Numarası",
                    "disabled": true,
                    "group":'Genel'
                },
                {
                    "value": "RegistrationCode",
                    "text": "Sicil Numarası",
                    "group":'Genel'
                },
                {
                    "value": "FullName",
                    "text": "Ad Soyad",
                    "disabled": true,
                    "group":'Genel'
                },
                {
                    "value": "Gender",
                    "text": "Cinsiyet",
                    "group":'Genel'
                },
                {
                    "value": "BloodGroup",
                    "text": "Kan Grubu",
                    "group":'Genel'
                },
                {
                    "value": "Disabled",
                    "text": "Engelli",
                    "group":'Genel'
                },
                {
                    "value": "MaritialStatus",
                    "text": "Medeni Durumu",
                    "group":'Genel'
                },
                {
                    "value": "DisabilityRate",
                    "text": "Engellilik Oranı",
                    "group":'Genel'
                },
                {
                    "value": "Harmful",
                    "text": "İşe Alımı Sakıncalı",
                    "group": "Genel"
                },
                {
                    "value": "HarmfulReason",
                    "text": "İşe Alımı Sakıncalı Nedeni",
                    "group": "Genel"
                },
                {
                    "value": "CollarStatus",
                    "text": "Yaka",
                    "group": "Organizasyonel"
                },
                {
                    "value": "OBranch",
                    "text": "Org. Şube",
                    "group": "Organizasyonel"
                },
                {
                    "value": "OEntryDate",
                    "text": "Org. Şube Giriş Tarihi",
                    "group": "Organizasyonel"
                },
                {
                    "value": "OExitDate",
                    "text": "Org. Şube Çıkış Tarihi",
                    "group": "Organizasyonel"
                },
                {
                    "value": "SBranch",
                    "text": "SGK Şube",
                    "group": "SGK"
                },
                {
                    "value": "SEntryDate",
                    "text": "SGK Şube Giriş Tarihi",
                    "group": "SGK"
                },
                {
                    "value": "SExitDate",
                    "text": "SGK Şube Çıkış Tarihi",
                    "group": "SGK"
                },
                {
                    "value": "SExitBranch",
                    "text": "SGK Çıkış Şubesi",
                    "group": "SGK"
                },
                 {
                    "value": "IstenCikisSebebiTuru",
                    "text": "İşten Çıkış Sebebi Türü",
                    "group": "SGK"
                },
                 {
                    "value": "IstenCikisAnaSebebi",
                    "text": "İşten Çıkış Ana Sebebi",
                    "group": "SGK"
                },
                  {
                    "value": "IstenCikisOzelSebebi",
                    "text": "İşten Çıkış Özel Sebebi",
                    "group": "SGK"
                },
                {
                    "value": "IstenCikisOzelAltSebebi",
                    "text": "İşten Çıkış Özel Alt Sebebi",
                    "group": "SGK"
                },
                {
                    "value": "HerSeyDahil",
                    "text": "Her Şey Dahil Çıkış",
                    "group": "SGK"
                },
                {
                    "value": "Dummy",
                    "text": "Dummy (Temsili) Çıkış",
                    "group": "SGK"
                },
                {
                    "value": "SigortaliTuru",
                    "text": "Sigortalı Türü",
                    "group": "SGK"
                },
                {
                    "value": "BankName",
                    "text": "Banka",
                    "group":'Genel'
                },
                {
                    "value": "IBAN",
                    "text": "IBAN",
                    "group":'Genel'
                },
                {
                    "value": "ContactGSM",
                    "text": "Telefon",
                    "group":'Genel'
                },
                {
                    "value": "DriverLicenseInfo",
                    "text": "Ehliyet Bilgisi",
                    "group":'Genel'
                },
                {
                    "value":"DigitalLicenseNumber",
                    "text":"Dijital Ehliyet Numarası",
                    "group":"Genel"
                },
                {
                    "value":"Address",
                    "text":"Adres",
                    "group":"Genel"
                },
                {
                    "value":"RelativeInfo",
                    "text":"Yakınları Bilgileri",
                    "group":"Yakını"
                },
                {
                    "value": "BirthDate",
                    "text": "Doğum Tarihi",
                    "group":'Genel'
                },
                {
                    "value": "EducationStatus",
                    "text": "Öğrenim Durumu",
                    "group":'Genel'
                },
                {
                    "value": "WorkingYears",
                    "text": "Kıdem Bilgisi",
                    "group":'SGK'
                },
                {
                    "value": "EducationDetail",
                    "text": "Öğrenim Detayı",
                    "group":'Genel'
                },
                {
                    "value": "TicketCardsCommaSeperated",
                    "text": "Ticket Kart Bilgisi",
                    "group":'Genel'
                },
                {
                    "value": "OccupationTitle",
                    "text": "Meslek Kodu",
                    "group": "SGK"
                },
                {
                    "value": "Garage",
                    "text": "Garaj",
                    "group": "Organizasyonel"
                },
                {
                    "value": "GarageStartDate",
                    "text": "Garaj Başlangıç Tarihi",
                    "group": "Organizasyonel"
                },
                {
                    "value": "GarageEndDate",
                    "text": "Garaj Bitiş Tarihi",
                    "group": "Organizasyonel"
                },
                {
                    "value": "EYT",
                    "text": "EYT",
                    "group": "SGK"
                },
                {
                    "value": "Department",
                    "text": "Bölüm",
                    "group": "Organizasyonel"
                },
                {
                    "value": "DepartmentTitle",
                    "text": "Unvan",
                    "group": "Organizasyonel"
                }
            ],
            loading:false
        }
    },
    methods:{
        getBloods(){
            SystemDataApi.Blood().then(response=>{
                this.bloods = response.data.Data
            })
        },
        getMaritialStatuses(){
            SystemDataApi.MaritialStatus().then(response=>{
                this.maritialStatuses = response.data.Data
            })
        },
        getSGKBranches(){
            CompanyApi.Branch.ListByCode("S").then(res=>{
                this.sgkBranches = res.data.Data
            })
        },
        getOBranches(){
            CompanyApi.Branch.ListByCode("O").then(res=>{
                this.oBranches = res.data.Data
            })
        },
        getCollarStatuses(){
            SystemDataApi.CollarStatus().then(res => {
                this.collarStatuses = res.data.Data
            })
        },
        searchOT(search){
            if(search){
                this.loadingOT = true
                SystemDataApi.OccupationTitlePrefix(search)
                .then(res=>{
                    const exist = structuredClone(this.jobCode) || []
                    this.jobCodes = res.data.Data?.map(d=>({
                        ...d,
                        Combine:[d.SGKOccupationCode,d.Name].join(' - ')
                    }))
                    exist.forEach(j => {
                        if(!this.jobCodes.find(c => c.Id == j.Id)) this.jobCodes.unshift(j)
                    });
                    this.loadingOT = false
                }).catch(err=>{
                    this.loadingOT = false
                })
            }
        },
        getGarages(){
            VehicleOperationsApi.Garage.List().then(res=>{
                this.garages = res.data.Data?.map(g => ({
                    ...g,
                    Combine:[g.BranchName,g.GarageName].join(' - ')
                })).sort((t,d)=> t.BranchName.localeCompare(d.BranchName))
            })
        },
        getDepartments(){
            HumanResourcesParametersApi.EmployeeDepartment.List().then(res => {
                this.departments = res.data.Data?.map(e => ({
                    ...e,
                    Combine:[e.Branch?.Name || '**',e.Name].join(' - ')
                })).sort((t,d)=> (t.Branch?.Name && d.Branch?.Name) ? t.Branch?.Name.localeCompare(d.Branch?.Name) : false)
            })
        },
        getTitles(){
            HumanResourcesParametersApi.EmployeeDepartmentTitle.ListAll().then(res => {
                this.titles = res.data.Data?.map(t=> ({
                    ...t,
                    Combine:[t.BranchName,t.EmployeeDepartmentName,t.Name].join(' - ')
                }))
            })
        },
        addSelected(f){
            if(!this.selectedFields.includes(f.value)) this.selectedFields.push(f.value)
            else this.selectedFields = this.selectedFields.filter(ff => ff != f.value)
        },
        send(){
            const data = {
                ...this.request,
                Fields:this.selectedFields.map((i) => {
                    const f = this.fields.find(ff => ff.value == i)
                    return {
                        Key:i,
                        Value:f?.text || null
                    }
                })
            }
            this.loading = true
            EmployeeOperationsApi.Report.PersonnelReport(data).then(res => {
                if(res.data.Success){
                    Additional.DownloadTab(res.data.Data.ExcelPath)
                }else{
                    this.$result(res)
                }
                this.loading = false
            }).catch(err => {
                this.loading = false
                this.$result(null,err)
            })
        }
    },
    computed:{
        c_fields(){
            return Additional.GroupBy(this.fields,'group')
        },
        maritialStatus:{
            get:function(){
                return this.maritialStatuses.filter(s=>this.request.MaritialStatusIds.includes(s.Id))
            },
            set:function(value){
                this.request.MaritialStatusIds = value?.map(c=> c.Id) || null
            }
        },
        blood:{
            get:function(){
                return this.bloods.filter(s=>this.request.BloodGroupIds.includes(s.Id))
            },
            set:function(value){
                this.request.BloodGroupIds = value?.map(c=> c.Id) || null
            }
        },
        sgkBranch:{
            get:function(){
                return this.sgkBranches.filter(s=>this.request.SGKBranchIds.includes(s.Id))
            },
            set:function(value){
                this.request.SGKBranchIds = value?.map(c=> c.Id) || null
            }
        },
        oBranch:{
            get:function(){
                return this.oBranches.filter(s=>this.request.OperationalBranchIds.includes(s.Id))
            },
            set:function(value){
                this.request.OperationalBranchIds = value?.map(c=> c.Id) || null
            }
        },
        jobCode:{
            get:function(){
                return this.jobCodes.filter(s=>this.request.OccupationTitleIds.includes(s.Id))
            },
            set:function(value){
                this.request.OccupationTitleIds = value?.map(c=> c.Id) || null
            }
        },
        collarStatus:{
            get:function(){
                return this.collarStatuses.filter(s=>this.request.CollarStatusIds.includes(s.Id))
            },
            set:function(value){
                this.request.CollarStatusIds = value?.map(c=> c.Id) || null
            }
        },
        garage:{
            get:function(){
                return this.garages.filter(s=>this.request.VehicleInventoryGarageIds.includes(s.Id))
            },
            set:function(value){
                this.request.VehicleInventoryGarageIds = value?.map(c=> c.Id) || null
            }
        },
        department:{
            get:function(){
                return this.departments.filter(s=>this.request.EmployeeDepartmentIds.includes(s.Id))
            },
            set:function(value){
                this.request.EmployeeDepartmentIds = value?.map(c=> c.Id) || null
            }
        },
        title:{
            get:function(){
                return this.titles.filter(s=>this.request.EmployeeDepartmentTitleIds.includes(s.Id))
            },
            set:function(value){
                this.request.EmployeeDepartmentTitleIds = value?.map(c=> c.Id) || null
            }
        },
    }
}
</script>
